import { render, staticRenderFns } from "./BusinessConfig.vue?vue&type=template&id=028b7754&"
import script from "./BusinessConfig.vue?vue&type=script&lang=js&"
export * from "./BusinessConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusinessConfig.vue"
export default component.exports